/* Bandenmeesters — one desktop disclosure shell, using the existing garage. */
(()=>{
  if(window.__bmMegaMenuRuntime)return;
  window.__bmMegaMenuRuntime=true;
  const desktop=window.matchMedia('(min-width:990px)');
  const nativeExactVehicleHref = (vehicle) => {
    if (!vehicle?.vehicleId || !vehicle.vehiclePageUrl) return '';
    try {
      const current = new URL(window.location.href);
      const target = new URL(vehicle.vehiclePageUrl, current.origin);
      const canonical = target.hostname === 'bandenmeesters.be' || target.hostname === 'www.bandenmeesters.be';
      if (target.protocol !== 'https:' || target.port || target.username || target.password
        || target.search || target.hash || (!canonical && target.origin !== current.origin)
        || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/[^/]+\/[^/]+\/?$/.test(target.pathname)) return '';
      const id = current.searchParams.get('preview_theme_id') || '';
      return target.pathname + (/^\d+$/.test(id) ? '?preview_theme_id=' + id : '');
    } catch (_) { return ''; }
  };
  const draftVehicleResultsHref=()=>{
    const path='/collections/nieuwe-velgen?browse=vehicle';
    try {
      const id=new URL(window.location.href).searchParams.get('preview_theme_id');
      return /^\d+$/.test(id||'') ? path+'&preview_theme_id='+id : path;
    } catch (_) { return path; }
  };
  const syncVehicle=()=>{
    const api=window.BandenmeestersVehicle;
    const vehicle=api?.getActive?.();
    document.querySelectorAll('.bm-mega__vehicle').forEach(card=>{
      card.querySelector('[data-bm-menu-vehicle-label]').textContent=vehicle?api.vehicleLabel(vehicle):'Kies jouw auto';
      const change=card.querySelector('[data-bm-menu-vehicle-change]');
      change.firstChild.textContent=vehicle?'Wijzig auto ':'Kies jouw auto ';
      const results=card.querySelector('[data-bm-menu-vehicle-results]');
      const url=vehicle?.newVehicle
        ? nativeExactVehicleHref(vehicle.newVehicle) || (vehicle.newVehicle.vehicleId ? draftVehicleResultsHref() : null)
        : vehicle?.generation?.url;
      results.hidden=!url;
      if(url)results.href=url;else results.removeAttribute('href');
    });
  };
  const init=(scope=document)=>{
    const wrapper=scope.querySelector('#header .navigation-wrapper');
    if(!wrapper||wrapper.dataset.bmMegaReady)return;
    wrapper.dataset.bmMegaReady='true';
    const entries=[...wrapper.querySelectorAll('.navigation-main>.navigation-item')].map(item=>({item,trigger:item.querySelector(':scope>[data-bm-mega-trigger]'),panel:item.querySelector(':scope>.bm-theme-mega')})).filter(e=>e.trigger&&e.panel);
    if(!entries.length)return;
    const shell=document.createElement('div');
    shell.className='bm-desktop-menu-shell';
    shell.setAttribute('aria-hidden','true');
    shell.inert=true;
    wrapper.appendChild(shell);
    entries.forEach((entry,index)=>{
      entry.panel.id='BmDesktopMenu-'+index;
      entry.panel.hidden=true;
      entry.trigger.setAttribute('aria-controls',entry.panel.id);
      shell.appendChild(entry.panel);
    });
    let active=null,openTimer,closeTimer,hideTimer;
    const clear=()=>{window.clearTimeout(openTimer);window.clearTimeout(closeTimer)};
    const close=()=>{
      clear();
      shell.classList.remove('is-open');
      shell.setAttribute('aria-hidden','true');
      shell.inert=true;
      if(active){active.trigger.setAttribute('aria-expanded','false');active.item.classList.remove('is-mega-open');}
      active=null;
      window.clearTimeout(hideTimer);
      hideTimer=window.setTimeout(()=>{if(!active)entries.forEach(e=>e.panel.hidden=true)},220);
    };
    const open=entry=>{
      clear();if(!desktop.matches)return;
      if(active===entry)return;
      window.clearTimeout(hideTimer);
      if(active){active.trigger.setAttribute('aria-expanded','false');active.item.classList.remove('is-mega-open');}
      entries.forEach(e=>e.panel.hidden=e!==entry);
      active=entry;
      entry.trigger.setAttribute('aria-expanded','true');
      entry.item.classList.add('is-mega-open');
      shell.setAttribute('aria-hidden','false');
      shell.inert=false;
      shell.classList.add('is-open');
      syncVehicle();
    };
    const leave=()=>{clear();if(active?.panel.contains(document.activeElement))return;closeTimer=window.setTimeout(close,200)};
    entries.forEach(entry=>{
      entry.item.addEventListener('pointerenter',()=>{clear();if(active)open(entry);else openTimer=window.setTimeout(()=>open(entry),300)});
      entry.item.addEventListener('pointerleave',leave);
      entry.trigger.addEventListener('focus',()=>open(entry));
      entry.trigger.addEventListener('keydown',event=>{
        if(event.key==='ArrowDown'){event.preventDefault();open(entry);entry.panel.querySelector('a[href]')?.focus();}
      });
    });
    shell.addEventListener('pointerenter',clear);
    shell.addEventListener('pointerleave',leave);
    wrapper.addEventListener('focusout',event=>{if(!wrapper.contains(event.relatedTarget))close()});
    wrapper.addEventListener('keydown',event=>{
      if(event.key!=='Escape'||!active)return;
      event.preventDefault();const trigger=active.trigger;close();trigger.focus();close();
    });
    document.addEventListener('pointerdown',event=>{if(!wrapper.contains(event.target))close()});
    shell.addEventListener('click',event=>{if(event.target.closest('a[href]'))close()});
    desktop.addEventListener('change',close);
    window.addEventListener('pageshow',event=>{if(event.persisted)close()});
    syncVehicle();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('bm:vehicle:ready',syncVehicle);
  window.addEventListener('bm:vehicle:change',syncVehicle);
})();
